<template>
    <div>
        <div class="jf_container shuju clearfix">
            <myTab :tabData="tabData" @tab_index="handleTabIndex" style="margin-top: -15px;"></myTab>
            <!-- + 积分排名 + -->
            <div class="jf_conditionBox jifenpaim clearfix" v-if="tabIndex===0" style="margin-top: -15px;">
                <div class="dangyue">
                    <h4 style="float:left">当月排名</h4>
                    <el-date-picker
                        class="picker"
                        v-model="searchParamC.date"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        value-format="yyyy-MM-dd"
                        @change="getCurrentIntegral()"
                        style="float:left;margin: -10px 0 0 40px;"
                    ></el-date-picker>
                    <!-- <mySearch
                        class="my-search"
                        @searchData="searchDataC"
                        :paramData="searchParamC"
                        searchApi="point_record/current_ranking"
                        v-model="searchContentC"
                    ></mySearch> -->

                    <div class="rankWrap" v-if="currentQianSan && currentQianSan.length>0" >
                        <div class="rank2" @click="handleExchange(currentQianSan[1])">
                            <p v-if="currentQianSan[1]">{{currentQianSan[1].username}}</p>
                            <p v-if="currentQianSan[1]">
                                <span>{{currentQianSan[1].point_change}}</span>积分
                            </p>
                        </div>
                        <div class="rank1" @click="handleExchange(currentQianSan[0])">
                            <p>{{currentQianSan[0].username}}</p>
                            <p>
                                <span>{{currentQianSan[0].point_change}}</span>积分
                            </p>
                        </div>
                        <div class="rank3" @click="handleExchange(currentQianSan[2])">
                            <p v-if="currentQianSan[2]">{{currentQianSan[2].username}}</p>
                            <p v-if="currentQianSan[2]">
                                <span>{{currentQianSan[2].point_change}}</span>积分
                            </p>
                        </div>
                    </div>

                    <el-table class="elTable" :data="currentTable">
                        <el-table-column prop="username" label="姓名" align="center"></el-table-column>
                        <el-table-column prop="rank" label="排行" align="center"></el-table-column>
                        <el-table-column prop="gangwei" label="岗位" align="center"></el-table-column>
                        <el-table-column prop="point_change" label="积分" align="center"></el-table-column>
                        <el-table-column prop="point_last" label="可兑换积分" align="center"></el-table-column>
                        <!--<el-table-column label="操作" align="center">-->
                            <!--<template slot-scope="scope">-->
                                <!--<el-button-->
                                    <!--@click="handleExchange(scope.row)"-->
                                    <!--type="text"-->
                                    <!--size="small"-->
                                    <!--style="color:#ff5454"-->
                                <!--&gt;兑换</el-button>-->
                            <!--</template>-->
                        <!--</el-table-column>-->
                    </el-table>
                </div>
                <div class="leiji">
                    <h4 style="float:left">累计排名</h4>
                    <!-- <div class="clearfix" >
                        <mySearch
                            class="my-search"
                            style="float:right"
                            @searchData="searchDataA"
                            v-model="searchContentA"
                            searchApi="point_record/all_ranking "
                        ></mySearch>
                    </div> -->
                    <div class="rankWrap" v-if="allQianSan && allQianSan.length>0">
                        <div class="rank2">
                            <p v-if="allQianSan[1]">{{allQianSan[1].username}}</p>
                            <p v-if="allQianSan[1]">
                                <span>{{allQianSan[1].point_all}}</span>积分
                            </p>
                        </div>
                        <div class="rank1">
                            <p>{{allQianSan[0].username}}</p>
                            <p>
                                <span>{{allQianSan[0].point_all}}</span>积分
                            </p>
                        </div>
                        <div class="rank3">
                            <p v-if="allQianSan[2]">{{allQianSan[2].username}}</p>
                            <p v-if="allQianSan[2]">
                                <span>{{allQianSan[2].point_all}}</span>积分
                            </p>
                        </div>
                    </div>

                    <el-table class="elTable" :data="allTable">
                        <el-table-column prop="username" label="姓名" align="center"></el-table-column>
                        <el-table-column prop="rank" label="排行" align="center"></el-table-column>
                        <el-table-column prop="gangwei" label="岗位" align="center"></el-table-column>
                        <el-table-column prop="point_all" label="积分" align="center"></el-table-column>
                    </el-table>
                </div>
                <!-- 兑换、记录弹窗 -->
                <div class="myDialog duihuan_dialog" v-if="showPopup">
                    <div class="myDialog_content shenqing-myDialog_content">
                        <h4 class="myDialog_h">
                            请选择兑换礼品
                            <i
                                class="close el-icon-circle-close-outline"
                                @click="showPopup=0"
                            ></i>
                        </h4>
                        <p class="canExchange">可兑换积分：<span>{{canExchangeNum}}</span></p>
                        <div>
                            <h5 class="duihuanTitle">现金</h5>
                            <!-- <div class="inp_wrap">
                                <label>金额:</label>
                                <el-input type="number" v-model="exchangeMoney"></el-input>&nbsp;元
                            </div> -->

                            <div class="inp_wrap">
                                <label>积分数:</label>
                                <el-input type="number" v-model="exchangeMoney"
                                :style="{'width':exchangeItem.exchange == 'no'?'170px!important':'150px!important'}"
                                :placeholder="exchangeItem.exchange == 'no'?canExchangeNum==0?'积分不足':exchangeItem.point_exchange_time+'后可兑换':''"

                                :disabled="exchangeItem.exchange == 'no'?true:false"></el-input>&nbsp;
                            </div>

                            <h5 class="duihuanTitle">礼品</h5>
                            <div class="inp_wrap">
                                <label>商品名称:</label>
                                <button class="showGoodsBtn" @click="dialogzeng=true">请选择商品</button>
                            </div>
                            <ul class="giftImg" v-if="giftData.length>0">
                                <li v-for="(img, index) in giftData" :key="index+600">
                                    <i class="el-icon-error" @click="deleteGoods(index)"></i>
                                    <img :src="img" alt="gift" />
                                </li>
                            </ul>
                            <div class="btnWrap">
                                <button class="assort_confim-btn" @click="exchangeMoney = '';selectedGift = [];giftData = [];showPopup=0">取消</button>
                                <button class="assort_confim-btn confim" @click="submitExchange">确定</button>
                            </div>
                    </div>
                </div>
                </div>
            </div>
            <!-- + 积分记录 + -->
            <div class="jf_conditionBox kaohe jifenjilu" v-if="tabIndex===1" style="margin-top: -15px;">
                <mySearch
                    class="my-search"
                    @searchData="searchData"
                    :paramData="searchParam"
                    searchApi="point_record/get_records"
                    v-model="searchContent"
                ></mySearch>
                <el-date-picker
                    class="picker"
                    v-model="date"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd"
                    @change="searchParam.date=date;getRecordsList()"
                ></el-date-picker>
                <el-select
                    class="topSelect"
                    v-model="searchParam.typeid"
                    placeholder="请选择分类"
                    clearable
                    @change="getRecordsList()"
                >
                    <el-option
                        v-for="item in assortArray"
                        :key="item.id+1000"
                        :label="item.typename"
                        :value="item.id"
                    >
                        <span :class="{'secondary': item.pid!==0}">{{item.typename}}</span>
                    </el-option>
                </el-select>
                <el-select
                    class="topSelect"
                    v-model="employeeInfo"
                    placeholder="姓名"
                    clearable
                    value-key="user_id"
                    @change="handleChooseName"
                >
                    <el-option
                        v-for="item in employeeList"
                        :key="item.user_id"
                        :label="item.username"
                        :value="item"
                    ></el-option>
                </el-select>
                <!-- <button class="createBtn" @click="showAddBox=true">批量删除</button> -->
                <!-- 数据表格 -->
                <el-table class="elTable" :data="recordsTable">
                    <!-- <el-table-column type="selection" width="30" align="right"></el-table-column> -->
                    <el-table-column prop="username" label="员工姓名" align="center" width="100"></el-table-column>
                    <el-table-column
                        prop="typename"
                        label="积分分类"
                        align="center"
                        :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                        prop="rule_name"
                        label="规则名称"
                        align="center"
                        :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                        prop="rule_des"
                        label="积分细则"
                        align="center"
                        :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column label="奖惩分数" align="center">
                        <template slot-scope="scope">
                            <span
                                :style="{'color':scope.row.rule_type==1?'#67C23A':'#F56C6C'}"
                            >{{scope.row.rule_type==1?'+':'-'}}{{scope.row.score}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="标准分数" align="center">
                        <template slot-scope="scope">
                            <span>
                                {{scope.row.score_type == 1 ? scope.row.score_fixed: scope.row.score_min+' ~ '+scope.row.score_max}}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="create_name" label="录入人" align="center"></el-table-column>
                    <el-table-column prop="check_time" label="申请日期" align="center"></el-table-column>
                    <!-- <el-table-column label="操作" align="center">
                        <template slot-scope="scope">
                            <el-button
                                @click="showDialog(scope.row.id)"
                                type="text"
                                size="small"
                                style="color:#ff5454"
                            >删除</el-button>
                        </template>
                    </el-table-column>-->
                </el-table>
                <!-- 页码 -->
                <p
                    class="pageTotal"
                >共有 {{pageData.count}} 条记录 当前 {{pageData.page}} 页/共 {{pageData.pagetotal}} 页</p>
                <el-pagination
                    class="pageBody"
                    @current-change="getRecordsList(1)"
                    :current-page.sync="pageData.page"
                    background
                    layout="prev, pager, next"
                    :total="pageData.count*1"
                ></el-pagination>
            </div>
        </div>
        <!-- 添加赠品图片弹框 -->
        <el-dialog
            id="newlist"
            class="mynewlist"
            title="title"
            :visible.sync="dialogzeng"
            width="80%"
            center
        >
            <span slot="title" class="dialog-title">
                <div class="demo-input-suffix all">
                    <el-row>
                        <el-col :span="12">
                            <div class="grid">
                                全部分类:
                                <el-select
                                    class="all_kind"
                                    size="small"
                                    style="width: 160px;"
                                    v-model="search.kind"
                                    clearable
                                    placeholder="全部分类"
                                    @change="loaddata"
                                >
                                    <el-option
                                        v-for="item in good_types"
                                        :key="item.id"
                                        :label="item.type_name"
                                        :value="item.id"
                                    ></el-option>
                                </el-select>
                            </div>
                        </el-col>
                        <el-col :span="12">
                            <div
                                class="grid gridnimei"
                                style="width: 180px;"
                                @keyup.enter="searchname"
                            >
                                <el-input
                                    class="all_kind "
                                    size="small "
                                    placeholder="请输入商品名称"
                                    v-model="search.name"
                                >
                                    <div slot="append" class="el-icon-search" @click="searchname"></div>
                                </el-input>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </span>
            <span>
                <el-table
                    ref="multipleTable"
                    :data="tableData.data"
                    tooltip-effect="dark"
                    style="width: 100%"
                    @selection-change="handleSelectionChange"
                    height="440px"
                    border
                >
                    <el-table-column type="selection" width="30"></el-table-column>
                    <el-table-column prop="good_num" label="商品编号" width="150" align="center"></el-table-column>
                    <el-table-column prop="good_name" label="商品名称" align="center"></el-table-column>
                    <!-- <el-table-column label="图片" align="center">
                        <template slot-scope="scope">
                            <span>
                                <img
                                    :src="scope.row.mini_imgpath"
                                    style="height: 30px;width: 30px;"
                                />
                            </span>
                        </template>
                    </el-table-column> -->
                    <!-- <el-table-column prop="spec" label="规格" align="center"></el-table-column> -->
                    <el-table-column prop="unit" label="单位" align="center"></el-table-column>
                    <el-table-column label="兑换积分" align="center">
                        <template slot-scope="scope">
                            {{scope.row.real_price*1}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="stock" label="可用库存" align="center"></el-table-column>
                    <el-table-column prop="limit" width="120" label="兑换数量" align="center">
                        <template slot-scope="scope" style="line-height:20px">
                            <el-input-number
                                @change="handleNumChange(scope.row)"
                                size="mini"
                                v-model="scope.row.limit"
                                :min="0"
                                :max="scope.row.stock"
                                label="描述文字"
                            ></el-input-number>
                        </template>
                    </el-table-column>
                </el-table>

                <p class="pager">
                    <span>共{{tableData.total}}条记录</span>
                    当前{{tableData.page}}页/共{{tableData.totalpage}}页
                </p>
                <el-pagination
                    class="f_page"
                    background
                    @current-change="handleCurrentChange"
                    :current-page="tableData.page"
                    layout="prev, pager, next"
                    :total="tableData.total"
                ></el-pagination>
            </span>
            <span slot="footer" class="dialog-footer">
                <el-row>
                    <el-col :span="12">
                        <div style="padding-left: 200px">
                            <el-button @click="dialogzeng = false">取 消</el-button>
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <div style="padding-right: 200px">
                            <el-button type="warning" @click="getgift">确 定</el-button>
                        </div>
                    </el-col>
                </el-row>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import myTab from "../../components/myTab.vue";
import mySearch from "../../components/mySearch.vue";

var baseUrl = process.env.apiUrl + "point/";
export default {
    name: "shuju",
    data() {
        return {
            tabData: ["积分排名", "积分记录"],
            tabIndex: 0,
            date: "",
            //----------------
            token: "",
            currentTable: [],
            allTable: [],
            currentQianSan: [],
            allQianSan: [],

            searchContentC: "", // 当月排名的搜索输入内容
            searchParamC: {
                date: "",
                placeholder: '输入员工姓名'
            },
            searchContentA: "", // 累计排名的搜索输入内容
            searchParamA: {
                date: ""
            },
            recordsTable: [], // 积分记录表格数据
            pageData: {
                count: "", // 总条数
                page: 1, // 当前页
                pagetotal: "" // 总页数
            }, // 页数
            assortArray: [],
            parentAssortId: "",
            employeeList: [],
            employeeInfo: {},
            searchContent: "",
            searchParam: {
                date: "",
                user_id: ""
            },
            showPopup: 0,
            exchangeId: "", // 兑换id
            //  商品弹窗内变了
            dialogzeng: false,
            search: {
                kind: "",
                name: ""
            },
            tableData: {
                data: [],
                page: 1,
                total: 0,
                totalpage: 10
            },
            good_types: [],
            multipleSelection: [],
            selectedGift: [],
            giftData: [],
            exchangeMoney: "",
            canExchangeNum: '',  // 可兑换积分
            exchangeItem: {
                exchange: '',
                point_exchange_time: ''
            }
        };
    },
    created() {
        this.token = this.$cookies.get("token");
        this.getCurrentIntegral();
        this.getAlltIntegral();
        this.getRecordsList();
        this.getAssortList();
        this.getEmployee();
        this.loaddata();
        this.getGoodsType();
    },
    methods: {
        // 获取当月积分列表
        async getCurrentIntegral() {
            let that = this;
            try {
                let res = await that.$http.post(
                    baseUrl + "point_record/current_ranking",
                    {
                        token: that.token,
                        search: that.searchContentC,
                        time_s:
                            that.searchParamC.date &&
                            that.searchParamC.date.length > 0
                                ? that.searchParamC.date[0]
                                : "",
                        time_e:
                            that.searchParamC.date &&
                            that.searchParamC.date.length > 0
                                ? that.searchParamC.date[1]
                                : ""
                    }
                );
                if (res.status == 1) {
                    that.currentQianSan = res.data.slice(0, 3);
                    that.currentTable = res.data.slice(3);
                } else {
                    that.$message.error(res.msg);
                }
            } catch (err) {
                that.$message.error(err);
            }
        },
        // 获取全部积分列表
        async getAlltIntegral() {
            let that = this;
            try {
                let res = await that.$http.post(
                    baseUrl + "point_record/all_ranking",
                    {
                        token: that.token
                    }
                );
                if (res.status == 1) {
                    that.allQianSan = res.data.slice(0, 3);
                    that.allTable = res.data.slice(3);
                } else {
                    that.$message.error(res.msg);
                }
            } catch (err) {
                that.$message.error(err);
            }
        },
        searchDataC(res) {
            this.currentQianSan = res.data.slice(0, 3);
            this.currentTable = res.data.slice(3);
        },
        searchDataA(res) {
            this.allQianSan = res.data.slice(0, 3);
            this.allTable = res.data.slice(3);
        },
        searchData(data) {
            this.recordsTable = data.data;
            this.pageData.count = data.map.count;
            this.pageData.page = data.map.page*1;
            this.pageData.pagetotal = data.map.pagetotal;
        },
        // 积分记录列表
        async getRecordsList(type) {
            if (type !== 1) {
                this.pageData.page = 1
            }
            let that = this;
            try {
                let res = await that.$http.post(
                    baseUrl + "point_record/get_records",
                    {
                        token: that.token,
                        time_s:
                            that.date && that.date.length > 0
                                ? that.date[0]
                                : "",
                        time_e:
                            that.date && that.date.length > 0
                                ? that.date[1]
                                : "",
                        search: that.searchContent,
                        page: that.pageData.page,
                        typeid: that.searchParam.typeid,
                        user_id: that.searchParam.user_id
                    }
                );
                if (res.status === 1) {
                    that.recordsTable = res.data;
                    that.pageData.count = res.map.count;
                    that.pageData.page = res.map.page*1;
                    that.pageData.pagetotal = res.map.pagetotal;
                } else {
                    that.$message.error(res.msg);
                }
            } catch (err) {
                that.$message.error(err);
            }
        },
        // 获取员工列表
        async getEmployee() {
            let that = this;
            try {
                let res = await that.$http.post(
                    baseUrl + "point_check/get_user_info",
                    {
                        token: that.token
                    }
                );
                if (res.status == 1) {
                    that.employeeList = res.allusers;
                    that.enter_user = res.username;
                } else {
                    that.$message.error(res.msg);
                }
            } catch (err) {
                that.$message.error(err);
            }
        },
        // 获取分类列表
        async getAssortList() {
            let that = this;
            try {
                let res = await that.$http.post(baseUrl + "point_type/index", {
                    token: that.token
                });
                if (res.status == 1) {
                    if (res.data && res.data.length > 0) {
                        that.assortArray = [];
                        res.data.forEach((element, index) => {
                            that.assortArray.push({
                                typename: element.typename,
                                pid: element.pid,
                                id: element.id
                            });
                            if (element.child && element.child.length > 0) {
                                element.child.forEach((ele, i) => {
                                    that.assortArray.push({
                                        typename: ele.typename,
                                        pid: ele.pid,
                                        id: ele.id
                                    });
                                });
                            }
                        });
                    }
                } else {
                    that.$message.error(res.msg);
                }
            } catch (err) {
                that.$message.error(err);
            }
        },
        handleTabIndex(data) {
            this.tabIndex = data;
        },
        handleChooseName() {
            this.searchParam.user_id = this.employeeInfo.user_id;
            this.getRecordsList();
        },
        // 商品弹窗函数
        // 搜索商品名称
        searchname() {
            this.tableData.page = 1;
            this.loaddata();
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        // 添加赠品图片
        getgift() {
            let selectedImg = [];
            this.selectedGift = [];
            for (
                let index = 0;
                index < this.multipleSelection.length;
                index++
            ) {
                const element = this.multipleSelection[index];
                selectedImg.push(element.mini_imgpath);
                this.selectedGift.push({
                    id: element.id,
                    num: element.limit
                });
                //判断赠品限量是否填写 不能为0
                if (element.limit == 0) {
                    this.$message.warning("商品限量不能为零");
                    selectedImg = [];
                    this.selectedGift = {};
                    return false;
                }
            }
            this.dialogzeng = false;
            this.giftData = selectedImg;
        },
        // 赠品接口
        loaddata() {
            var arr = this;
            $.ajax({
                url: baseUrl + "point_staff_center/goods_list",
                type: "post",
                data: {
                    token: arr.token,
                    search: arr.search.name,
                    typeid: arr.search.kind,
                    page: arr.tableData.page
                },
                success: function(response) {
                    if (response.map.count == 0) {
                        arr.tableData.data = [];
                        arr.tableData.total = 0;
                        arr.tableData.totalpage = 1;
                    } else {
                        arr.tableData.data = response.data;
                        arr.tableData.total = response.map.count;
                        arr.tableData.totalpage = response.map.pagetotal;
                    }
                }
            });
        },
        handleCurrentChange(val) {
            this.tableData.page = val;
            this.loaddata();
        },
        async getGoodsType() {
            let that = this;
            try {
                let res = await that.$http.post(
                    baseUrl + "point_staff_center/goods_type",
                    { token: that.token }
                );
                if (res.status == 1) {
                    that.good_types = res.data;
                } else {
                    that.$message.error(res.msg);
                }
            } catch (err) {
                that.$message.error(err);
            }
        },
        deleteGoods(i) {
            this.giftData.splice(i, 1);
            this.selectedGift.splice(i, 1);
        },
        // 兑换提交
        async submitExchange() {
            if (this.exchangeMoney == "" && this.selectedGift.length === 0) {
                this.$message.warning("请兑换现金红包或者礼品");
                return;
            }
            let that = this;
            try {
                let res = await that.$http.post(
                    baseUrl + "point_staff_center/exchange_goods",
                    {
                        token: that.token,
                        score: that.exchangeMoney,
                        goods_id: that.selectedGift,
                        type: 1,
                        user_id: that.exchangeId
                    }
                );
                if (res.status == 1) {
                    that.$message.success("兑换成功");
                    that.getCurrentIntegral();
                    that.exchangeMoney = "";
                    that.selectedGift = [];
                    that.giftData = [];
                    that.showPopup = 0;
                } else {
                    that.$message.error(res.msg);
                }
            } catch (err) {
                that.$message.error(err);
            }
        },
        handleExchange(item) {
            return false;
            this.exchangeItem.exchange = item.exchange
            this.exchangeItem.point_exchange_time = item.point_exchange_time
            this.showPopup = 1;
            this.exchangeId = item.user_id
            this.canExchangeNum = item.point_last
        },
        handleNumChange(row) {
            if (row.limit*1 > 0) {
                this.$refs.multipleTable.toggleRowSelection(row, true)
            } else {
                this.$refs.multipleTable.toggleRowSelection(row, false)
            }
        }
    },
    components: {
        myTab,
        mySearch
    }
};
</script>
<style scoped>
.shuju {
    /* min-width: 1250px; */
    height: 100%;
    background: #f1f1f1;
}
.dangyue,
.leiji {
    overflow-y: scroll;
    float: left;
    margin-left: 10px;
    width: 48%;
    /* min-width: 610px; */
    /* height: calc(100vh - 250px); */
    padding: 20px 14px;
    background: #fff;
}
.jf_conditionBox h4 {
    margin-bottom: 20px;
    font-size: 16px;
    font-weight: 600;
}
.elTable {
    margin: 0 auto;
    width: 90%;
}
.rankWrap {
    display: flex;
    justify-content: center;
    margin: 40px 0 20px;
    height: 200px;
    text-align: center;
}
.rankWrap div {
    box-sizing: border-box;
    display: inline-block;
    width: 106px;
    height: 144px;
    padding-top: 68px;
    cursor: pointer;
}
.rankWrap div p {
    font-size: 16px;
    line-height: 26px;
}
.rankWrap div p span {
    color: #E6BE8A;
}
.rank2 {
    align-self: flex-end;
    background: url("/static/qmsj/img/jifen/ranking2.png") no-repeat;
    background-size: contain;
}
.rank1 {
    margin: 0 30px;
    background: url("/static/qmsj/img/jifen/ranking1.png") no-repeat;
    background-size: contain;
}
.rank3 {
    align-self: flex-end;
    background: url("/static/qmsj/img/jifen/ranking3.png") no-repeat;
    background-size: contain;
}
.jifenjilu {
    padding: 10px 0 0 30px;
    background: #fff;
}
.jifenjilu .elTable {
    margin: 20px 0 0 !important;
    width: 95%;
}
.jifenjilu .createBtn {
    float: right;
    margin-right: 5%;
    border: none;
    font-size: 16px;
    line-height: 50px;
    color: #E6BE8A;
    background: none;
}
.myDialog_content {
    width: 500px;
}
.duihuan_dialog .picker {
    margin: 20px;
}
.duihuanTitle {
    margin: 30px 0 -10px 0;
    padding-left: 30px;
    font-size: 16px;
    font-weight: 700;
    color: #333;
}
.btnWrap {
    text-align: center;
}
.btnWrap .assort_confim-btn {
    display: inline-block;
    margin: 30px 20px 0;
}
.confim {
    color: #fff;
    background: #E6BE8A;
}
.close {
    float: right;
    margin: 8px 20px;
}

/* ****************************************************************************************** */
#newlist .dialog-title {
    background-color: #E6BE8A;
    width: 100%;
    height: 50px;
    display: inline-block;
    padding-top: 10px;
}
#newlist .el-dialog__header {
    padding: 0;
}
#newlist .all {
    color: white;
}
#newlist .el-table thead {
    color: #7c7f85;
}
#newlist .el-table td,
#newlist .el-table th {
    padding: 0;
}
#newlist .el-checkbox__input.is-checked .el-checkbox__inner,
#newlist .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #E6BE8A;
    border-color: #E6BE8A;
}
#newlist .el-checkbox__inner:hover {
    border-color: #E6BE8A;
}
#newlist .el-input-number--mini .el-input-number__decrease,
#newlist .el-input-number--mini .el-input-number__increase {
    background: #fff;
    color: #E6BE8A;
    border: 1px solid #E6BE8A;
    border-radius: 50%;
    width: 18px;
    height: 18px;
    line-height: 16px;
    top: 8px;
    /* margin-left: 10px;
        margin-right: 10px; */
}
#newlist .el-checkbox__original {
    display: none;
}
#newlist .el-input-number--mini {
    width: 100px;
    line-height: 26px;
}
#newlist .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #E6BE8A;
    color: #fff;
}
#newlist .el-pagination.is-background .btn-next,
#newlist .el-pagination.is-background .btn-prev,
#newlist .el-pagination.is-background .el-pager li {
    margin: 0;
}
#newlist .el-button--primary {
    color: #fff;
    background-color: #E6BE8A;
    border-color: #E6BE8A;
}
#newlist .el-button--primary:focus,
#newlist .el-button--primary:hover {
    background: #E6BE8A;
    border-color: #E6BE8A;
    color: #fff;
}
#newlist .el-button {
    padding: 8px 15px;
}
#newlist .el-table__body {
    color: rgb(153, 153, 153);
}
.pager {
    color: rgb(153, 153, 153);
}
.pager span {
    margin-right: 5px;
}
.f_page {
    text-align: center;
}
#newlist .el-date-editor .el-range-input::placeholder {
    color: rgb(153, 153, 153);
}
#newlist .el-input__inner::placeholder {
    color: rgb(153, 153, 153);
}
#newlist .el-radio__input.is-checked .el-radio__inner {
    /* border-color: red; */
    background: #E6BE8A;
    border: 0;
}
#newlist .el-radio__input.is-checked + .el-radio__label {
    color: rgb(153, 153, 153);
}
#newlist .el-radio {
    color: rgb(153, 153, 153);
    margin-left: 5px;
}
#newlist .el-radio__inner:hover {
    border-color: rgb(153, 153, 153);
}
#newlist .el-radio__label {
    padding-left: 5px;
}
#newlist .el-radio + .el-radio {
    margin-left: 15px;
}
#newlist .el-input-group__append {
    background: white;
    border-radius: 0 20px 20px 0;
    padding: 0 10px 0;
}
/*#newlist .el-input__inner{*/
/*padding: 0 0 0 10px;*/
/*}*/
.my_span {
    width: 15px;
    height: 15px;
    border-radius: 50%;
    border: 1px solid rgb(153, 153, 153);
}
#newlist .el-table .cell {
    line-height: 15px;
}
#newlist .el-table th,
.el-table tr {
    line-height: 25px;
}
#newlist .el-dialog--center .el-dialog__body {
    text-align: center;
}
#newlist .el-dialog--center .el-dialog__body {
    padding: 0;
}
.showGoodsBtn {
    outline: none;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    width: 200px;
    height: 40px;
    font-size: 14px;
    background: none;
}
.giftImg {
    display: flex;
    flex-wrap: wrap;
    margin-top: 20px;
    width: 100%;
    padding: 0 30px;
}
.giftImg li {
    position: relative;
    margin: 8px 16px 8px 0;
}
.giftImg li i {
    position: absolute;
    top: -8px;
    right: -8px;
    width: 16px;
    height: 16px;
    font-size: 16px;
    cursor: pointer;
}
.giftImg li img {
    display: block;
    width: 60px;
    height: 50px;
}
.canExchange {
    position: absolute;
    top: 50;
    right: 14px;
    font-size: 14px;
}
.canExchange span {
    font-weight: 600;
    font-size: 16px;
}
.secondary {
    margin-left: 30px;
}
</style>



// WEBPACK FOOTER //
// src/pages/jifen/shuju.vue